// import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import {
  useNavigate,
  createSearchParams,
  URLSearchParamsInit,
} from 'react-router-dom';

import Layout from '../../../layouts/User';
import styles from './index.module.scss';

export type Props = {};

interface menu {
  label: string;
  url: string;
  icon: string;
}

const MenuTechnician: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [menuList, setMenuList] = useState<menu[]>([]);

  const getMenuList = () => {
    setMenuList([
      {
        label: 'ข้อมูลและรายละเอียดช่าง',
        // url: '/my-technician/profile',
        url: '/apply-job',
        icon: '/images/serviceJob/icon-technician-profile.svg',
      },
      {
        label: 'งานใหม่จากลูกค้า',
        url: '/my-technician/orders/',
        icon: '/images/serviceJob/icon-technician-order.svg',
      },
      // {
      //   label: 'ใบเสนอราคาค่าประเมิน',
      //   url: '/my-technician/invoices/',
      //   icon: '/images/serviceJob/icon-technician-quotation.svg',
      // },
      // {
      //   label: 'งานในระบบ',
      //   url: '/my-technician/jobs/',
      //   icon: '/images/serviceJob/icon-technician-job.svg',
      // },
    ]);
  };

  const MenuListShortcuts = () => {
    return (
      <>
        <div className={styles.menuContainer}>
          {menuList.map((menu) => (
            <div className={styles.menu} key={menu.label}>
              <div
                className={styles.category}
                onClick={() => navigate(`${menu.url}`)}
              >
                <div>
                  <img
                    className={styles.menuImg}
                    src={menu.icon}
                  ></img>
                </div>
                <div className={styles.catLabel}>{menu.label}</div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  useEffect(() => {
    getMenuList();
  }, []);

  return (
    <>
      <div style={{ marginTop: '2rem' }}>
        <div style={{ textAlign: 'center' }}>
          {loading ? (
            <LoadingOutlined className={styles.loadingIcon} />
          ) : (
            <MenuListShortcuts />
          )}
        </div>
      </div>
    </>
  );
};

export default MenuTechnician;
